// eslint-disable-next-line no-unused-vars
import React, { Component } from "react";
import { ImageString } from "../../../const/assets/ImageString";
import "./Tut.css";
import dj__logo from "./dj-logo.svg";
import welcome__logo from "./welcom__logo.svg";
import arrow from "../../auth/login/arrow.svg";
import Button from "@material-ui/core/Button";
const states = {
  introCard: 0,
};

const HeaderBackground = {
  background: "url(/assets/images/bg-add.png)",
  backgroundPosition: "center",
  backgroundSize: "contain",
};

const TutCard = [
  {
    link: "/3dAssets/UI/Tut/arrows.jpg",
    header: "Arrows",
    description: " Tap the left and right arrows to view more.",
  },
  {
    link: "/3dAssets/UI/Tut/hotspot.jpg",
    header: "Hotspots",
    description: "Tap on any hotspot to enter that section.",
  },
  {
    link: "/3dAssets/UI/Tut/Menu.jpg",
    header: "Menu",
    description: "Use the menu icons for quick navigation",
  },
];

export default class LobbyTut extends Component {
  state = {
    currentState: states.introCard,
  };

  handleContinue = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.props.skip();
  };

  showNextCard = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState((prev) => ({
      currentState: prev.currentState + 1,
    }));
  };

  render() {
    return (
      <>
        <div className="lobbyTutContainer">
          {this.state.currentState === states.introCard && (
            <>
              <div className="tut-box">
                <div className="head">
                  <img src="/assets/images/login/login-logo.png" alt="" />
                </div>
                <div className="content">
                  <h2>Title Page</h2>
                  <br />
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Felis iaculis sit non id tellus. Cum at blandit semper
                    viverra elementum nibh scelerisque diam risus. Laoreet felis
                    eget vitae consectetur. Rhoncus orci, proin dignissim amet.
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Debitis voluptatibus labore similique non obcaecati. Qui
                    error reiciendis deleniti? Necessitatibus laboriosam quam a
                    consectetur animi officia, ab vero facilis dolor est sunt
                  </p>
                </div>
                <div className="box-button">
                  <button onClick={(e) => this.handleContinue(e)}>
                    Explore
                  </button>
                </div>
              </div>
            </>
          )}
          {this.state.currentState === states.tutCard && (
            <div className="tutCardContainer tutCardContainer-sm">
              <div className="tutCardContainer-header">
                <div className="whiteText">Tutorial</div>
              </div>
              <div className="tutCardContainer-body">
                {TutCard.map((item) => (
                  <div key={item.header} className="tutCardContainer-bodyItem">
                    <img alt={item.header} src={item.link}></img>
                    <div className="bodyItem-text">
                      <h2>{item.header}</h2>
                      <div>{item.description}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center">
                <button
                  className="tutCardButton btn  btn-yellow mg-t30"
                  onClick={(e) => this.handleContinue(e)}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
          {this.state.currentState === states.leaderboard && (
            <div className="tutCardContainer width-cal">
              <div
                className="tutCardContainer-header ptb-extra justify-content-between bottom-border"
                style={HeaderBackground}
              >
                <img
                  src={ImageString.LOGOR1_old}
                  alt="logo1"
                  className="invi"
                ></img>
                <img
                  src={ImageString.LOGOKOA}
                  alt="logo2"
                  className="invi"
                ></img>
              </div>
              <div className="tutCardContainer-body tutCardContainer-body-extraPd">
                <div className="tutCardContainer-body-textContainer">
                  <strong>
                    <h3>Overall Event Leaderboard</h3>
                  </strong>
                  <br></br>
                  Please visit all the zones of the the virtual event to gain
                  points &amp; be amongst the top of the leaderboard.
                  <br></br>
                  Please visit your profile section to know more.
                  <br></br>
                  <button
                    className="tutCardButton btn  btn-yellow mg-t30"
                    onClick={(e) => this.handleContinue(e)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}
